import { makeStyles } from '@material-ui/core/styles';
import { colors } from 'theme/color-palette';
const { FONT_COLOR, GREY, PURPLE } = colors;
import { Bogle_Regular } from 'constants/constant';

const linkedItemsFormStyle = makeStyles(() => ({
	relative: {
		position: 'relative'
	},
	titleContainer: {
		position: 'relative'
	},
	titleFont: {
		fontSize: '20px',
		fontFamily: Bogle_Regular,
		fontWeight: 300,
		height: '50px',
		display: 'flex',
		alignItems: 'center',
		marginLeft: '16px'
	},
	titleIcon: {
		marginRight: '8px'
	},
	closeIcon: {
		position: 'fixed',
		right: '8px',
		justifyContent: 'end',
		color: PURPLE
	},
	contentContainer: {
		marginLeft: '20px',
		color: FONT_COLOR,
		fontSize: '16px',
		maxWidth: '320px'
	},
	allLinkRadio: {
		'&.MuiIconButton-root': {
			margin: '10px'
		}
	},
	descriptionLable: {
		color: GREY,
		fontSize: '12px',
		marginLeft: '28px',
		whiteSpace: 'pre-wrap'
	}
}));

export default linkedItemsFormStyle;
